module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAVFBMVEUAAAA2Q1o2Qlo3Q1s2Qls3Q1s3Qlo3QlplZWo2Q1o5Q1s3Q1o3Q1s4Qls3RVs5R1xCQ142Q1s3Q1s6SF82Q1s2Q1s4Qlw8Rl83Qls3Q1s4RFw2QlriK4CmAAAAG3RSTlMA3ptY8Yr2vQTPNKx5aEYkEuGAIuazTBmtlUBd8PAwAAAAyklEQVRIx+2W2QrDIBBFE5dq9mZPO///n20kYlFhRgqFgudpIHNukhevBcq9IKKHvpNNJQCPrHnLVAkWPPKiVKzltRXCyBEuRNXIrh90YYgIXqT3kxEBwEWGgEeQEQq3DzAheFr+i7Bv07rggtuFE5Jw7QoliYLZ5bOZcMFNWchCFsw0bXuScLKsb4sozFwqYSyi4Cyy4KzfHpU1swjiGyRYqJ/0AJi4AassG8dgnJNKUTdQpdWuPp7RYj9csY/xYkd7Hr68nCRff14fUjB1Zlwh/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/other_to_ofd.png
// module id = ZGWq
// module chunks = 2